module.exports = __webpack_public_path__ + "static/media/logo.0ec475f7.svg";